(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('UniversityInternalController', UniversityInternalController);

    /** @ngInject */
    function UniversityInternalController($scope, $state, $stateParams, $rootScope, UniversityService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getVideoImage = () => {
            return HelperService.imageResizePath('videos', vm.video.Id, vm.video.Image, 400, 200);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function recordPersonVisualization() {
            if (vm.video.HasPersonRead) return;

            let userData = AuthenticationService.getUserData();
            let accessLogData = {
                VideoId: vm.video.Id,
                PersonId: userData.Id
            }

            UniversityService
                .postAccessLog(accessLogData);
        }

        function getVideo() {
            HelperService.startLoading('.video-internal');

            vm.isLoading = true;

            let userData = AuthenticationService.getUserData();

            UniversityService
                .getByUrl($stateParams.universityUrl, userData.Id, userData.Responsibility.Id)
                .then(success => {
                    vm.video = success;
                    vm.isLoading = false;

                    recordPersonVisualization();

                    HelperService.stopLoading('.video-internal');
                }, error => {
                    HelperService.errorCallback(error);
                    $state.go('app-master.default.university');
                })
        }

        function initVars() {
            vm.isLoading = false;
            vm.comments = [];
            vm.isLoadingComments = true;
        }

        function init() {
            initVars();
            getVideo();
        }
    }
}());